import { render, staticRenderFns } from "./MyIntroduce2.vue?vue&type=template&id=3de9f68a&scoped=true"
import script from "./MyIntroduce2.vue?vue&type=script&lang=js"
export * from "./MyIntroduce2.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce2.vue?vue&type=style&index=0&id=3de9f68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9f68a",
  null
  
)

export default component.exports